/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Tracking_Exception_FailedInputs */

const tr_geliver_tracking_exception_failed = /** @type {(inputs: Geliver_Tracking_Exception_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teslim başarısız`)
};

const en_geliver_tracking_exception_failed = /** @type {(inputs: Geliver_Tracking_Exception_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery failed`)
};

const de_geliver_tracking_exception_failed = /** @type {(inputs: Geliver_Tracking_Exception_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zustellung fehlgeschlagen`)
};

const ru_geliver_tracking_exception_failed = /** @type {(inputs: Geliver_Tracking_Exception_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доставка не удалась`)
};

/**
* | output |
* | --- |
* | "Delivery failed" |
*
* @param {Geliver_Tracking_Exception_FailedInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_tracking_exception_failed = /** @type {((inputs?: Geliver_Tracking_Exception_FailedInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Tracking_Exception_FailedInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_tracking_exception_failed(inputs)
	if (locale === "de") return de_geliver_tracking_exception_failed(inputs)
	if (locale === "ru") return ru_geliver_tracking_exception_failed(inputs)
	return tr_geliver_tracking_exception_failed(inputs)
});